import { Button } from '@mui/material'
import AlphabetGrid from '../AlphabetGrid';
import { useState } from 'react';
import KeyedCipherEncryption from './KeyedCipherEncryption';
import KeyedCipherDecryption from './KeyedCipherDecryption';
import CustomButton from '../CustomButton';
// import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';

const KeyedCipherSimulation = () => {
  const [plainText, setPlainText] = useState("")
  const [cipherText, setCipherText] = useState("")
  const [key, setKey] = useState("")
  const [sortedKey, setSortedKey] = useState("")
  const [clickedSimulate, setClickedSimulate] = useState(false)
  const [encryptionDone, setEncryptionDone] = useState(false)
  const [isSimulating, setIsSimulating] = useState(false);
  const [isKeyValid, setIsKeyValid] = useState(true)

  // For Decryption
  const[dec_plainText, setDecPlainText] = useState("")
  const [dec_cipherText, setDecCipherText] = useState("")
  const [dec_key, setDecKey] = useState("")
  const [dec_sortedKey, setDecSortedKey] = useState("")

  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async function encrypt(plainText, key) {
    setEncryptionDone(false);
    setCipherText('');
    setPlainText('');
    setKey('');
    setSortedKey('');
    setDecCipherText('');
    setDecPlainText('');
    setDecKey('');
    setDecSortedKey('');
    
    let repeatedKey = (key.repeat(Math.floor(plainText.length / key.length))) + key.slice(0, plainText.length % key.length);
    let indexedText = Array.from(repeatedKey, (char, index) => [char, index]);
    let sortedText = indexedText.sort((a, b) => a[0].localeCompare(b[0]) || a[1] - b[1]);

    let cipherText = '';
    let pt = '';
    let ptCount = 0;
    let sortedK = '';
    let k = ''
    let kCount = 0;

    for(let i = 0; i < sortedText.length; i++){
      pt += plainText.charAt(ptCount);
      ptCount++;
      setPlainText(pt);
      await sleep(300);
    }

    for (let i = 0; i < sortedText.length; i++) {
      k += repeatedKey.charAt(kCount);
      kCount++;
      setKey(k);
      await sleep(300);
    }
    for (let i = 0; i < sortedText.length; i++) {
      sortedK += sortedText[i][0];
      setSortedKey(sortedK);
      await sleep(300);
    }
    for (let i = 0; i < sortedText.length; i++) {
      cipherText += plainText.charAt(sortedText[i][1])
      setCipherText(cipherText);
      await sleep(300)
    }
    
    setEncryptionDone(true);

    cipherText = '';
    pt = '';
    ptCount = 0;
    sortedK = '';
    k = ''
    kCount = 0;

    for (let i = 0; i < sortedText.length; i++) {
      cipherText += plainText.charAt(sortedText[i][1])
      setDecCipherText(cipherText);
      await sleep(300)
    }

    for (let i = 0; i < sortedText.length; i++) {
      sortedK += sortedText[i][0];
      setDecSortedKey(sortedK);
      await sleep(300);
    }

    for (let i = 0; i < sortedText.length; i++) {
      k += repeatedKey.charAt(kCount);
      kCount++;
      setDecKey(k);
      await sleep(300);
    }

    for (let i = 0; i < sortedText.length; i++) {
      pt += plainText.charAt(ptCount);
      ptCount++;
      setDecPlainText(pt);
      await sleep(300);
    }

    setIsSimulating(false);
    return cipherText;
  }

  function handleSubmit(e) {

    e.preventDefault();
    if (!isSimulating) {
      setIsSimulating(true);
      // Read the form data
      const form = e.target;
      const formData = new FormData(form);
      const formJson = Object.fromEntries(formData.entries());
      console.log(formJson);
      var k = formData.get("key");
      var pt = formData.get("plaintext").toUpperCase();

      if(k.length > pt.length){
        setIsKeyValid(false);
        setIsSimulating(false);
      }else{
        var res = encrypt(pt, k);
        setClickedSimulate(true)
        setIsKeyValid(true);
        console.log(res);
      }
      
    }

  }

  return (
    <>
      <form method="post" onSubmit={handleSubmit}>
        <label>
          Plain Text (only alphabets, without spaces):
          <input pattern="[a-zA-Z]+" style={{ textTransform: "uppercase" }} required={true} name="plaintext" />
        </label>
        <label>
          Key (sequence of integers):
          <input name="key" required={true} type="number" />
          
        </label>
        <CustomButton type="submit" isSimulating={isSimulating}>{isSimulating ? 'Simulating...' : 'Simulate'}</CustomButton>
        {/* <Button variant="contained" type='submit' size='medium' disabled={isSimulating}>{isSimulating ? 'Simulating...' : 'Simulate'}</Button> */}
        
      </form>
      <p style={{ display: isKeyValid ? "none" : "inline", color: "red", fontSize: 15 }}>Invalid Key! Key length should be less than or equal to plaintext length</p>
      <br />
      <div style={{ display: clickedSimulate ? "block" : "none" }} >
        <KeyedCipherEncryption plainText={plainText} cipherText={cipherText} ogKey={key} sortedKey={sortedKey} />
      </div>
      <div style={{ display: encryptionDone ? "block" : "none" }} >
        <hr />
        <KeyedCipherDecryption plainText={dec_plainText} cipherText={dec_cipherText} ogKey={dec_key} sortedKey={dec_sortedKey} />
      </div>
    </>
  )
}

export default KeyedCipherSimulation